import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext } from 'src/M_Components'
import { DoubleArrowOutlined, Refresh, InsertLinkOutlined } from '@mui/icons-material'


export const SequenceMovementCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 

    const accountService = new BufferService('Account')
    const equipmentStatusService = new BufferService('EquipmentStatus', 'secondary')
    const equipmentConditionService = new BufferService('EquipmentCondition', 'secondary')
    const movementLinkService = new BufferService('MovementLink', 'secondary')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    // Options
    const linkTypeOptions = [
        { label: t('Next'), value: 'Next' },
        { label: t('Demurrage'), value: 'Demurrage' },
        { label: t('Handling Out'), value: 'Handling Out' },
        { label: t('Handling In'), value: 'Handling In' },
        { label: t('Load Date'), value: 'Load Date' },
        { label: t('Gate Date'), value: 'Gate Date' },
        { label: t('Book'), value: 'Book' },
        { label: t('Seal'), value: 'Seal' },
        { label: t('Container'), value: 'Container' },
        { label: t('New Cycle'), value: 'New Cycle' },
        { label: t('Gate In'), value: 'Gate In' },
        { label: t('Gate Out'), value: 'Gate Out' },
        { label: t('Terminal'), value: 'Terminal' },
    ]
    const boundOptions = [
        { label: t('Export'), value: 'Export' },
        { label: t('Import'), value: 'Import' },
        { label: t('Transit'), value: 'Transit' },
        { label: t('Internal'), value: 'Internal' },
        { label: t('Operations'), value: 'Operations' },
        { label: t('Other'), value: 'Other' },
    ]
    const locationOptions = [
        { label: t('None'), value: 'None' },
        { label: t('From'), value: 'From' },
        { label: t('To'), value: 'To' },
        { label: t('Final'), value: 'Final' },
    ]
    const fieldOptionsMap = {
        'outBound': boundOptions,
        'inBound': boundOptions,
        'outLocation': locationOptions,
        'inLocation': locationOptions,
    }

    // Fields
    const MoveLinkFields = [
        { display: t('Link')+' '+t('Type'), required: true, code: 'linkType', type: 'select', options: 'linkTypeOptions', extraField: 'linkTypeValue' },
        { display: t('Account ID'), required: true, code: 'accountCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'accountCode' }, { key: 'AccountName', value: 'accountName' }, { key: 'Id', value: 'accountId' }] },
        { display: t('Account')+' '+t('Name'), code: 'accountName', type: 'disabled' },
    ]
    const MoveLinkOutFields = [
        { display: t('Out')+' '+t('Code'), code: 'movOutCode', type: 'foreignKey', entity: 'MovementType', api: 'secondary', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'movOutName' }, { key: 'Code', value: 'movOutCode' }, { key: 'Id', value: 'movOutId' }] },
        { display: t('Out')+' '+t('Name'), code: 'movOutName', type: 'disabled' },
        // Code key added — backend OutMatches compares against EquipmentStatus.Code, not Name
        { display: t('Out')+' '+t('EquipmentStatus'), code: 'outEqStatus', type: 'foreignKey', entity: 'EquipmentStatus', api: 'secondary', filterField: 'Code', labelFields: ['Name'], fields: [{ key: 'Name', value: 'outEqStatus' }, { key: 'Code', value: 'outEqStatusCode' }, { key: 'Id', value: 'outEqStatusId' }] },
        // Code key added — backend OutMatches compares against EquipmentCondition.Code, not Name
        { display: t('Out')+' '+t('Condition'), code: 'outCondition', type: 'foreignKey', entity: 'EquipmentCondition', api: 'secondary', filterField: 'Code', labelFields: ['Name'], fields: [{ key: 'Name', value: 'outCondition' }, { key: 'Code', value: 'outConditionCode' }, { key: 'Id', value: 'outConditionId' }] },
        { display: t('Out')+' '+t('From')+' '+t('Location'), code: 'outFromLocation', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'],displayField: 'outFromLocation', fields: [{ key: 'LocationCode', value: 'outFromLocation' }, { key: 'Id', value: 'outFromLocationId' }] },
        { display: t('Out')+' '+t('To')+' '+t('Location'), code: 'outToLocation', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], displayField: 'outToLocation',fields: [{ key: 'LocationCode', value: 'outToLocation' }, { key: 'Id', value: 'outToLocationId' }] },
        { display: t('Out')+' '+t('Bound'), code: 'outBound', type: 'select', options: 'boundOptions', extraField: 'outBoundValue' },
        { display: t('Out')+' '+t('Location'), code: 'outLocation', type: 'select', options: 'locationOptions', extraField: 'outLocationValue' },
    ]
    const MoveLinkInFields = [
        { display: t('In')+' '+t('Code'), code: 'movInCode', type: 'foreignKey', entity: 'MovementType', api: 'secondary', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'movInName' }, { key: 'Code', value: 'movInCode' }, { key: 'Id', value: 'movInId' }] },
        { display: t('In')+' '+t(' Name'), code: 'movInName', type: 'disabled' },
        // Code key added — backend InMatches compares against EquipmentStatus.Code, not Name
        { display: t('In')+' '+t(' EquipmentStatus'), code: 'inEqStatus', type: 'foreignKey', entity: 'EquipmentStatus', api: 'secondary', filterField: 'Code', labelFields: ['Name'], fields: [{ key: 'Name', value: 'inEqStatus' }, { key: 'Code', value: 'inEqStatusCode' }, { key: 'Id', value: 'inEqStatusId' }] },
        // Code key added — backend InMatches compares against EquipmentCondition.Code, not Name
        { display: t('In')+' '+t(' Condition'), code: 'inCondition', type: 'foreignKey', entity: 'EquipmentCondition', api: 'secondary', filterField: 'Code', labelFields: ['Name'], fields: [{ key: 'Name', value: 'inCondition' }, { key: 'Code', value: 'inConditionCode' }, { key: 'Id', value: 'inConditionId' }] },
        { display: t('In')+' '+t('From')+' '+t('Location'), code: 'inFromLocation', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], displayField: 'inFromLocation', fields: [{ key: 'LocationCode', value: 'inFromLocation' }, { key: 'Id', value: 'inFromLocationId' }] },
        { display: t('In')+' '+t('To')+' '+t('Location'), code: 'inToLocation', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], displayField: 'inToLocation', fields: [{ key: 'LocationCode', value: 'inToLocation' }, { key: 'Id', value: 'inToLocationId' }] },
        { display: t('In')+' '+t('Bound'), code: 'inBound', type: 'select', options: 'boundOptions', extraField: 'inBoundValue' },
        { display: t('In')+' '+t('Location'), code: 'inLocation', type: 'select', options: 'locationOptions', extraField: 'inLocationValue' },
    ]

    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingMovementLink = JSON.parse(sessionStorage.getItem('editingMovementLink'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingMovementLink && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyMovementLink(editingMovementLink.Id, operationType === 'Copy')
                sessionStorage.removeItem('editingMovementLink')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {
            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshMovementLink = () => {
        ctx.setIsLoad(true)
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null)
        get()
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')
    }

    const handleError = (error) => {
        let errorMessage = 'Error saving movement link'
        
        // AxiosError response body is in error.response?.data
        const responseData = error?.response?.data ?? error

        if (Array.isArray(responseData)) {
            errorMessage = responseData.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (responseData?.errors) {
            // ASP.NET ModelState / FluentValidation errors object
            errorMessage = Object.entries(responseData.errors)
                .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
                .join('\n')
        } else if (responseData?.message) {
            errorMessage = responseData.field
                ? `${responseData.field}: ${responseData.message}`
                : responseData.message
        } else if (responseData?.detail) {
            errorMessage = responseData.detail
        } else if (responseData?.title) {
            // ASP.NET ProblemDetails — title alone isn't enough, combine with errors if present
            const detail = responseData.detail ? `\n${responseData.detail}` : ''
            errorMessage = `${responseData.title}${detail}`
        } else if (error?.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }

    const onSave = async () => {
        if (!data.linkType || !data.accountId) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }
        
        const movementLinkData = {
            Type: data.linkType,
            AccountId: data.accountId,
            Name: data.accountCode,
            AccountVATNumber: data.accountVATNumber || null,
            
            // OUT fields
            OutCode: data.movOutCode || null,
            OutName: data.movOutName || null,
            // Fixed: send Code not Name — backend OutMatches compares against EquipmentStatus.Code
            MovementEquipmentStatusOutCode: data.outEqStatusCode || null,
            MovementFromOutCode: data.outFromLocation || null,
            MovementToOutCode: data.outToLocation || null,
            // Fixed: send Code not Name — backend OutMatches compares against EquipmentCondition.Code
            MovementConditionOutCode: data.outConditionCode || null,
            MovementTypeOutBound: data.outBoundValue || null,
            OutLocationField: data.outLocationValue || null,
            
            // IN fields
            InCode: data.movInCode || null,
            InName: data.movInName || null,
            // Fixed: send Code not Name — backend InMatches compares against EquipmentStatus.Code
            MovementEquipmentStatusInCode: data.inEqStatusCode || null,
            MovementFromInCode: data.inFromLocation || null,
            MovementToInCode: data.inToLocation || null,
            // Fixed: send Code not Name — backend InMatches compares against EquipmentCondition.Code
            MovementConditionInCode: data.inConditionCode || null,
            MovementTypeInBound: data.inBoundValue || null,
            InLocationField: data.inLocationValue || null,
        }

        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? movementLinkService.update(editingId, movementLinkData) 
            : movementLinkService.post(movementLinkData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            const successMessage = isEditMode 
                ? t('Sequence Mov.') + t('updatedSucessfully') 
                : t('Sequence Mov.') + t('savedSucessfully')
            ctx.toastMessages('success', '', successMessage)
            ctx2.closeTab(JSON.parse(id))
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyMovementLink = (movementLinkId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        movementLinkService.getId(movementLinkId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to load')+' '+t('Sequence Mov.'))
                return
            }
            
            const movementLinkData = {
                linkType: response.Type,
                linkTypeValue: response.Type,
                accountId: response.AccountId,
                accountName: response.Name || '',
                accountVATNumber: response.AccountVATNumber?.toString() || '',
                
                // OUT fields
                movOutCode: response.OutCode || '',
                movOutName: response.OutName || '',
                // Code stored in dedicated key — consistent with field definition and payload
                outEqStatusCode: response.MovementEquipmentStatusOutCode || '',
                outEqStatus: response.MovementEquipmentStatusOutCode || '',
                outFromLocation: response.MovementFromOutCode || '',
                outToLocation: response.MovementToOutCode || '',
                outConditionCode: response.MovementConditionOutCode || '',
                outCondition: response.MovementConditionOutCode || '',
                outBound: response.MovementTypeOutBound,
                outBoundValue: response.MovementTypeOutBound,
                outLocation: response.OutLocationField,
                outLocationValue: response.OutLocationField,
                
                // IN fields
                movInCode: response.InCode || '',
                movInName: response.InName || '',
                // Code stored in dedicated key — consistent with field definition and payload
                inEqStatusCode: response.MovementEquipmentStatusInCode || '',
                inEqStatus: response.MovementEquipmentStatusInCode || '',
                inFromLocation: response.MovementFromInCode || '',
                inToLocation: response.MovementToInCode || '',
                inConditionCode: response.MovementConditionInCode || '',
                inCondition: response.MovementConditionInCode || '',
                inBound: response.MovementTypeInBound,
                inBoundValue: response.MovementTypeInBound,
                inLocation: response.InLocationField,
                inLocationValue: response.InLocationField,
                
                _isCopy: isCopy,
                _originalId: isCopy ? movementLinkId : null
            }

            if (isCopy) {
                delete movementLinkData.Id
                delete movementLinkData.ExternalId
                delete movementLinkData.CreatedAt
                delete movementLinkData.UpdatedAt
                setIsEditMode(false)
                setEditingId(null)
                setOperation('Copy')
            } else {
                setIsEditMode(true)
                setEditingId(movementLinkId)
                setOperation('Edit')
            }

            setData(movementLinkData)

            if (response.EquipmentStatusId) {
                equipmentStatusService.getId(response.EquipmentStatusId).then(equipmentStatus => {
                    if (equipmentStatus.name !== 'AxiosError') {
                        changes('status', equipmentStatus.Code, setData)
                    }
                })
            }
            if (response.EquipmentConditionId) {
                equipmentConditionService.getId(response.EquipmentConditionId).then(equipmentCondition => {
                    if (equipmentCondition.name !== 'AxiosError') {
                        changes('conditionCode', equipmentCondition.Code, setData)
                    }
                })
            }
            if (response.AccountId) {
                accountService.getId(response.AccountId).then(accountRes => {
                    if (accountRes.name !== 'AxiosError') {
                        changes('accountCode', accountRes.AccountName, setData)
                    }
                })
            }

        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading movement:', error)
            ctx.toastMessages('error', '', t('Failed to load')+' '+t('Sequence Mov.'))
        })
    }

    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshMovementLink()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save"></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><InsertLinkOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t('Movement')+' '+t('Link')+' '+t('Details')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {MoveLinkFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, null, '250px', linkTypeOptions)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: !matches10 && 'auto' || 'auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><DoubleArrowOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t('Movement')+' '+t('Link')+' '+t('Out')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches13 && 'auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                {MoveLinkOutFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, null, '250px', fieldOptionsMap[field.code])
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><DoubleArrowOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t('Movement')+' '+t('Link')+' '+t('In')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches13 && 'auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                {MoveLinkInFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, null, '250px', fieldOptionsMap[field.code])
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div>
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => ctx2.closeTab(JSON.parse(id))} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div>
    )
}